// extracted by mini-css-extract-plugin
export default {"passwordReset":"Button_passwordReset__1i6Nm"};